/**
 * usePasskeySupport — WebAuthn / passkey のブラウザ対応検出 hook（共有版）。
 *
 * `@auth/client-passkey` の `detectBrowserSupport()` をラップし、feature-detect 結果を
 * React 状態として提供する。ログイン UI はこの状態で passkey 導線を出すか判断し、
 * 非対応環境では silent degrade する。ダッシュボードから `@auth/ui-react` へ昇格。
 */
import { detectBrowserSupport } from "@auth/client-passkey";
import React from "react";
/**
 * マウント時に `detectBrowserSupport()` を実行し、結果を状態へ反映する hook。
 * 検出自体が失敗した場合も silent degrade（非対応扱い）で完了する。
 * アンマウント後は状態更新しない（act / leak 警告回避）。
 */
export function usePasskeySupport() {
    const [state, setState] = React.useState({
        isChecking: true,
        webAuthnSupported: false,
        conditionalMediationSupported: false,
    });
    React.useEffect(() => {
        let mounted = true;
        void detectBrowserSupport()
            .then((support) => {
            if (!mounted)
                return;
            setState({
                isChecking: false,
                webAuthnSupported: support.webAuthnSupported,
                conditionalMediationSupported: support.conditionalMediationSupported,
            });
        })
            .catch(() => {
            if (!mounted)
                return;
            setState({
                isChecking: false,
                webAuthnSupported: false,
                conditionalMediationSupported: false,
            });
        });
        return () => {
            mounted = false;
        };
    }, []);
    return state;
}
